import { isLegacyWebtransferBrand } from '../utils/miniAppBrand';
import { KREDAFI_ARTICLES, KREDAFI_CATEGORIES } from './knowledgeBaseKredafi';
import { LEGACY_ARTICLES, LEGACY_CATEGORIES } from './knowledgeBaseLegacy';

/**
 * База знаний.
 *
 * Ребрендинг KredaFi переписал статьи по существу — новая архитектура,
 * кредитный пул. Мини-апп в Telegram в ребрендинг не входил и читает прежний
 * текст; веб и приложение KredaFi — новый. Поэтому базы две.
 */
export interface KnowledgeArticle {
  id: string;
  category: "products" | "ecosystem" | "affiliates" | "about";
  categoryTitle: { ru: string; en: string };
  title: { ru: string; en: string };
  shortDescription: { ru: string; en: string };
  icon: string;
  tags: string[];
  contentRu: string;
  contentEn: string;
}

export const KNOWLEDGE_ARTICLES: KnowledgeArticle[] = isLegacyWebtransferBrand
  ? LEGACY_ARTICLES
  : KREDAFI_ARTICLES;

export const KNOWLEDGE_CATEGORIES = isLegacyWebtransferBrand
  ? LEGACY_CATEGORIES
  : KREDAFI_CATEGORIES;

export const getArticleById = (id: string): KnowledgeArticle | undefined => {
  return KNOWLEDGE_ARTICLES.find(a => a.id === id);
};
